import call from "@brainspore/celadon-base/service/http";
import { helper } from "@/packages/dashboard/utils";
import RemarkConstants from "@/packages/exams/modules/Remark/RemarkConstants";

export default {
  namespaced: true,
  state: {
    remarks: [],
    remark: {},
    attachmentDialog: false,
    proforma: "",
    receipt: "",
    remarkUnits: [],
    canApply: "",
  },
  mutations: {
    MUTATE: (state, payload) => {
      state[payload.state] = payload.data;
    },
  },
  getters: {
    remarkGetter: (state) => (val) => state[val],
  },
  actions: {
    setAttachmentDialog({ commit }, payload) {
      commit("MUTATE", { state: "attachmentDialog", data: payload });
    },
    remarkUnits({ commit }) {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("get", RemarkConstants.REMARK_UNITS)
        .then((res) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          commit("MUTATE", {
            state: "remarkUnits",
            data: res.data.data,
          });
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.response.data.message);
        });
    },
    // GET remark
    getExamRemarks: ({ commit }, payload) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("get", RemarkConstants.EXAM_REMARK, payload)
        .then((res) => {
          commit("MUTATE", {
            state: "remarks",
            data: res.data.data,
          });
          commit("Dashboard/SET_LOADING", false, { root: true });
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.response.data.message);
        });
    },
    // GET remark
    getExamRemark: ({ commit }, payload) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      let decryptedCode = helper.decrypt(payload);
      call("get", RemarkConstants.SHOW_EXAM_REMARK(decryptedCode))
        .then((res) => {
          commit("MUTATE", {
            state: "remark",
            data: res.data.data.shift(),
          });
          commit("Dashboard/SET_LOADING", false, { root: true });
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.response.data.message);
        });
    },
    // POST remarks
    examRemark: ({ commit }, payload) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("post", RemarkConstants.EXAM_REMARK, payload)
        .then((res) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiSuccess", res.data.message);
          Event.$emit("goToPayment", res.data.data[0].no);
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.response.data.message);
        });
    },
    // patch deferrals
    patchRemark: ({ commit }, payload) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("post", RemarkConstants.PATCH_EXAM_REMARK, payload)
        .then((res) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiSuccess", "Successfully Updated Exam Remark Entry");
          if (res.data.data.postedReceiptNo === "") {
            Event.$emit("goToPayment", res.data.data.no);
          }
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.response.data.message);
        });
    },
    // delete deferrals
    deleteRemark: ({ commit, dispatch }, payload) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("post", RemarkConstants.DELETE_EXAM_REMARK, payload)
        .then(() => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiSuccess", "Successfully deleted exam remark entry");
          dispatch("getExamRemarks");
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.response.data.message);
        });
    },
    deleteAttachment({ commit, dispatch }, payload) {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("post", RemarkConstants.deleteAttachment, payload)
        .then(() => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiSuccess", "Successfully deleted Attachment");
          dispatch("getExamRemark", helper.encrypt(payload.documentNo));
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.response.data.message);
        });
    },
    getRemarkProforma({ commit }, payload) {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("get", RemarkConstants.proforma(payload))
        .then((res) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          commit("MUTATE", {
            state: "proforma",
            data: process.env.VUE_APP_TEMP_URL + res.data.data[0],
          });
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.response.data.message);
        });
    },
    getRemarkReceipt({ commit }, payload) {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("get", RemarkConstants.receipt(payload))
        .then((res) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          commit("MUTATE", {
            state: "receipt",
            data: process.env.VUE_APP_TEMP_URL + res.data.data[0],
          });
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.response.data.message);
        });
    },
    deleteLine({ commit, dispatch }, payload) {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("post", RemarkConstants.deleteLine, payload)
        .then(() => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          dispatch("getExamRemark", helper.encrypt(payload.documentNo));
          Event.$emit("ApiSuccess", "Successfully deleted Exam Remark Line");
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.response.data.message);
        });
    },
    checkCanApplyForRemark({ commit }) {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("get", RemarkConstants.checkCanApplyForRemark).then((res) => {
        commit("Dashboard/SET_LOADING", false, { root: true });
        commit("MUTATE", {
          state: "canApply",
          data: res.data.data.shift(),
        });
      });
    },
  },
};
